import { render } from "./CommercialBlockCreateEdit.vue?vue&type=template&id=ebd1caf2"
import script from "./CommercialBlockCreateEdit.vue?vue&type=script&lang=js"
export * from "./CommercialBlockCreateEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__